import React from 'react';
import { Card, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { CART_TABLE } from '../../constants/table';
import useBreakpoint from '../../hooks/useBreakpoint';
import Icon from '../icon/Icon';
var COLUMN = CART_TABLE.COLUMN;
var OtherChargeRow = function(param) {
    var description = param.description, amount = param.amount, infoMessage = param.infoMessage, isReadOnly = param.isReadOnly;
    var isEnabledForBreakpoint = useBreakpoint([
        'md',
        'lg',
        'xl'
    ]);
    return /*#__PURE__*/ React.createElement("tr", {
        className: "other-charges-row"
    }, /*#__PURE__*/ React.createElement("td", {
        className: "p-0 pb-2"
    }, /*#__PURE__*/ React.createElement(Card, {
        className: ""
    }, /*#__PURE__*/ React.createElement(Card.Body, null, /*#__PURE__*/ React.createElement("div", {
        className: "product-row d-flex flex-row other-charges-row justify-content-between align-items-center"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "other-charge-text d-flex flex-row align-items-center font-12"
    }, description, infoMessage && /*#__PURE__*/ React.createElement(OverlayTrigger, {
        trigger: [
            'hover',
            'focus'
        ],
        placement: "top",
        overlay: /*#__PURE__*/ React.createElement(Tooltip, {
            id: "other-charge-tooltip"
        }, infoMessage)
    }, /*#__PURE__*/ React.createElement(Icon, {
        icon: "question",
        className: "other-charge-icon",
        style: {
            pointerEvents: 'auto'
        }
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "other-charge-value font-12 font-weight-normal"
    }, amount))))));
};
export default OtherChargeRow;
